import defaultTheme from "tailwindcss/defaultTheme";

const { fontFamily } = defaultTheme;

const spaceUnit = 8;

export const BaseTheme = {
  spacing: {
    0: "0px",
    0.2: `${spaceUnit / 4}px`,
    0.5: `${spaceUnit / 2}px`,
    1: `${spaceUnit}px`,
    1.5: `${spaceUnit * 1.5}px`,
    2: `${spaceUnit * 2}px`,
    2.5: `${spaceUnit * 2.5}px`,
    3: `${spaceUnit * 3}px`,
    4: `${spaceUnit * 4}px`,
    5: `${spaceUnit * 5}px`,
    7: `${spaceUnit * 7}px`,
    8: `${spaceUnit * 8}px`,
    10: `${spaceUnit * 10}px`,
    11: `${spaceUnit * 11}px`,
    12: `${spaceUnit * 12}px`,
    13: `${spaceUnit * 13}px`,
    18: `${spaceUnit * 18}px`,
    "input-padding-y": `${spaceUnit * 1}px`,
    "input-padding-x": `${spaceUnit * 3}px`,
    "multiline-input-padding-y": `${spaceUnit * 1}px`,
    "multiline-input-padding-x": `${spaceUnit * 3}px`,
    "input-width": `100%`,
    'form-padding-top': '80px',
    'form-padding-left': '50px',
    'form-padding-bottom': '70px',
    'form-padding-right': '50px',
    'form-width': '100%',
    'video-card-play-button-padding-x': `${spaceUnit}px`,
    "video-card-play-button-bg": "#FFFFFF",
    "video-card-play-button-hover-bg": "#E3BBB3",
    'menu-link-margin': `${spaceUnit * .125}px`,
  },
  colors: {
    transparent: "transparent",
    base: {
      white: "#FFFFFF",
      grey: "#9C9896",
      "light-pink": "#FAE3DF",
      "medium-grey": "#767571",
      "dark-grey": "#474747",
      "videocardplaybutton": "#FFFFFF",
    },
    interactive: {
      green: "#596152",
      yellow: "#FFE500",
      pink: "#E3BBB3",
      black: "#1A1A1A",
      hamburger: "#333333",
      "top-nav": "#FFFFFF",
      "top-banner": "#E3BBB3",
      "image-card": "#FFFFFF",
      "video-card": "#EAE3DA",
      "quote-card": "#FFFFFF",
      button: "#EEE9DE",
      marquee: "#B0D7EC",
      "image-overlay": "#F7F4EF",
      "dynamic-form": "#F7F4EF",
      "landing-video": "#FFF",
      "columnTextImage-main":  "#F7F4EF",
      "columnTextImage-text-content-text": "#1A1A1A",
      "columnTextImage-text-content-label": "#1A1A1A",
      "circuit-contact-form": "", 
      "column-text-scrollable-card": "#ffffff",
      "video-card-play-button-bg": "transparent",
      "video-card-play-button-hover-bg": "transparent",
    },
    spinner: {
      "page": "#FFFFFF",
      "edge": "rgba(0, 0, 0, 0.10)",
      "label": "#333333"
    },
    footer: {
      "nav-link": "",
      "nav-link-hover": ""
    },
    feedback: {
      negative: "#CC0511",
      warning: {
        500: "#B85B00",
      },
      success: {
        100: "#C5E9D0",
        500: "#006531",
      },
    },
    input: {
      default: {
        text: "#1A1A1A",
        bg: "#fff",
        border: "#999",
        placeholder: "#767571",
      },
      disabled: {
        text: "#474747",
        bg: "#9C9896",
        placeholder: "#474747",
      },
      autofilled: {
        bg: "#DFEDFD"
      }
    },
    modal:{
      default: {
        bg: '#FFFFFF'
      },
      futures:{
        bg: '#FFDB00'
      }
    },
    button:{
      primary: {
        bg: '#FFE500',
        color: '#000000'
      },
      'primary-hover': {
        color: '#000000'
      },
      secondary: {
        bg: 'transparent',
        color: '#000000'
      },
      ghost: {
        bg: 'transparent',
        color: '#000000'
      }
    },
    'sticky-container': {
      bg: 'transparent'
    }
  },
  screens: {
    xs: '425px',
    sm: '576px',
    md: '1024px',
    lg: '1280px',
    xl: '1440px',
    xxl: '1920px',
    xxxl: '2560px'
  },
  fontFamily: {
    "noto-ikea": ["var(--font-noto-ikea)", ...fontFamily.sans],
    "lively-headline": ["var(--font-lively-headline)", ...fontFamily.sans],
  },
  fontSize: {
    // Display XL
    "display-xl": [
      "40px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-xl-sm": [
      "64px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-xl-md": [
      "88px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-xl-xl": [
      "128px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Display L
    "display-l": [
      "32px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-l-sm": [
      "56px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-l-md": [
      "64px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-l-xl": [
      "106px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Display M
    "display-m": [
      "24px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-m-sm": [
      "48px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-m-md": [
      "56px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-m-xl": [
      "96px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Display S
    "display-s": [
      "20px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-s-sm": [
      "40px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-s-md": [
      "48px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "display-s-xl": [
      "88px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Heading XL
    "heading-xl": [
      "32px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-xl-sm": [
      "48px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-xl-md": [
      "56px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-xl-xl": [
      "64px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Heading L
    "heading-l": [
      "24px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-l-sm": [
      "32px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-l-md": [
      "40px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-l-xl": [
      "48px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Heading M
    "heading-m": [
      "18px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-m-sm": [
      "20px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-m-md": [
      "24px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-m-xl": [
      "32px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Heading S
    "heading-s": [
      "16px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-s-sm": [
      "18px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-s-md": [
      "20px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    "heading-s-xl": [
      "24px",
      {
        fontWeight: "600",
        lineHeight: "110%",
      },
    ],
    // Body XL
    "body-xl": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-xl-sm": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-xl-md": [
      "24px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-xl-xl": [
      "32px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    // Body L
    "body-l": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-l-sm": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-l-md": [
      "20px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-l-xl": [
      "24px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    // Body L BOLD
    "body-l-bold": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "body-l-bold-sm": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "body-l-bold-md": [
      "20px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "body-l-bold-xl": [
      "24px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    // Body M
    "body-m": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-m-sm": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-m-md": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-m-xl": [
      "18px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    // Body S
    "body-s": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-s-sm": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-s-md": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "body-s-xl": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    // Body S BOLD
    "body-s-bold": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "body-s-bold-sm": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "body-s-bold-md": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "body-s-bold-xl": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    // Body XS
    "body-xs": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    // Body XXS
    "body-xxs": [
      "12px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    // Button
    "button-l": [
      "20px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
      },
    ],
    "button-m": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
        letterSpacing: "0.5px",
      },
    ],
    "button-s": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
        letterSpacing: "0.5px",
      },
    ],
    // Link
    "link-m": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "0.5px",
      },
    ],
    "link-m-bold": [
      "16px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
        letterSpacing: "0.5px",
      },
    ],
    "link-s": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "0.3px",
      },
    ],
    "link-s-bold": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
        letterSpacing: "0.3px",
      },
    ],
    "link-xs": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "0.3px",
      },
    ],
    "link-nav": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "600",
        letterSpacing: "0.3px",
      },
    ],
    // Label
    "label-m": [
      "18px",
      {
        lineHeight: "1.3",
        fontWeight: "600",
        letterSpacing: "0.2px",
      },
    ],
    // Input
    "input": [
      "14px",
      {
        lineHeight: "1.5",
        fontWeight: "400",
      },
    ],
    "navLink": [
      "0.875rem",
      {
        lineHeight: "0.8rem",
        fontWeight: "700",
      },
    ],
  },
  borderRadius: {
    none: "0",
    4: `${spaceUnit * 0.5}px`,
    8: `${spaceUnit}px`,
    12: `${spaceUnit * 1.5}px`,
    16: `${spaceUnit * 2}px`,
    32: `${spaceUnit * 4}px`,
    56: `${spaceUnit * 7}px`,
    full: "9999px",
    "top-banner": "5px",
    "input": `${spaceUnit * 0}px`
  },
  borderWidth: {
    "input": `1px`,
    "input-b": `2px`
  },
  aspectRatio: {
    "1/1": "1 / 1",
    "1/16": "1 / 16",
    "2/1": "2 / 1",
    "2/3": "2 / 3",
    "3/1": "3 / 1",
    "3/2": "3 / 3",
    "3/4": "3 / 4",
    "4/3": "4 / 3",
    "5/2": "5 / 2",
    "16/9": "16 / 9",
    "16/10": "16 / 10",
  },
  extend: {
    animation: {
      "loop-scroll": "loop-scroll 50s linear infinite",
    },
    keyframes: {
      "loop-scroll": {
        from: { transform: "translateX(0)" },
        to: { transform: "translateX(-100%)" },
      },
    },
  },
  boxShadow: {}
}